module.exports = __webpack_public_path__ + "static/media/project13.e4cd8716.jpg";